import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import ShoppingPage from './pages/ShoppingPage';
import AdminPage from './pages/AdminPage';
import LearningPage from './pages/LearningPage';
import VerbTrainerPage from './pages/VerbTrainerPage';
import VocabularyTrainerPage from './pages/VocabularyTrainerPage';
import AppShell from './components/layout/AppShell';
import { useAuth } from './hooks/useAuth';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppShell>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shopping" element={<ShoppingPage />} />
                <Route path="/learning" element={<LearningPage />} />
                <Route path="/verbs" element={<VerbTrainerPage />} />
                <Route path="/vocabulary" element={<VocabularyTrainerPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AppShell>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
